import { displayMessage } from "../../../helpers/messages";

// Mapeamento de tipos para exibição
const TYPE_LABELS = {
    weight_loss: displayMessage("WEIGHT_LOSS"),
    muscle_gain: displayMessage("MUSCLE_GAIN"),
};

// Mapeamento de gêneros para exibição
const GENDER_LABELS = {
    male: displayMessage("MALE"),
    female: displayMessage("FEMALE"),
};

const INTOLERANCE_LABELS = {
    none: "Nenhuma",
    lactose: "Lactose",
    gluten: "Glúten",
    vegetarian: "Vegetariano",
};

const diet_grid_columns = [
    {
        field: "id",
        headerName: displayMessage("ID"),
        flex: 0.5,
        minWidth: 60,
    },
    {
        field: "gender",
        headerName: displayMessage("GENDER"),
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
            return GENDER_LABELS[params.value] || params.value;
        },
    },
    {
        field: "type",
        headerName: displayMessage("DIET_TYPE"),
        flex: 1.5,
        minWidth: 150,
        renderCell: (params) => {
            return TYPE_LABELS[params.value] || params.value;
        },
    },
    {
        field: "meals_count",
        headerName: displayMessage("MEALS_COUNT"),
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
            return `${params.value} ${displayMessage("MEALS")}`;
        },
    },
    {
        field: "food_intolerance",
        headerName: "Intolerância",
        flex: 1.5,
        minWidth: 150,
        renderCell: (params) => {
            return INTOLERANCE_LABELS[params.value] || params.value;
        },
    },
    {
        field: "description",
        headerName: displayMessage("DESCRIPTION"),
        flex: 2,
        minWidth: 200,
        renderCell: (params) => {
            return params.value || "-";
        },
    },
    {
        field: "file",
        headerName: displayMessage("PDF_FILE"),
        flex: 1.5,
        minWidth: 150,
        renderCell: (params) => {
            return params.value || "-";
        },
    },
];

export default diet_grid_columns;
